import type {
  B2BPublicEventCategory,
  B2BRegistrationBase,
  CreateB2BRegistrationRequest,
} from 'api/requestTypes';
import type { B2bRegistrationFormValues } from './b2bRegistrationSchema';

const emptyToUndefined = (value: string | undefined | null): string | undefined => {
  const trimmed = value?.trim();
  if (trimmed == null || trimmed === '') {
    return undefined;
  }
  return trimmed;
};

const toOptionalPreviousEvents = (
  hasOrganizedBefore: boolean,
  previousEvents: string | undefined,
): string | undefined => {
  if (!hasOrganizedBefore) {
    return undefined;
  }
  return emptyToUndefined(previousEvents);
};

/**
 * Maps validated RHF values (incl. client-only `termsAccepted`) to the API request shape.
 * `publicEventCategory` is sent for every {@link B2bRegistrationFormValues.eventType}.
 */
export const mapB2bFormToCreateRequest = (
  values: B2bRegistrationFormValues,
): CreateB2BRegistrationRequest => {
  const base: B2BRegistrationBase = {
    fullName: values.fullName.trim(),
    companyOrOrganization: emptyToUndefined(values.companyOrOrganization),
    phoneNumber: values.phoneNumber.trim(),
    email: emptyToUndefined(values.email),
    city: values.city,
    websiteOrSocialMedia: emptyToUndefined(values.websiteOrSocialMedia),
    hasOrganizedBefore: values.hasOrganizedBefore,
    previousEvents: toOptionalPreviousEvents(values.hasOrganizedBefore, values.previousEvents),
    eventName: values.eventName.trim(),
    description: values.description.trim(),
    eventDate: emptyToUndefined(values.eventDate),
    eventTime: emptyToUndefined(values.eventTime),
    eventVenue: emptyToUndefined(values.eventVenue),
    isVenueConfirmed: values.isVenueConfirmed,
  };

  return {
    ...base,
    eventType: values.eventType,
    publicEventCategory: values.publicEventCategory as B2BPublicEventCategory,
  };
};
